import useBodyClass from '@components/Hooks/useBodyClass';
import Termite from '@divtel/termite';
import React from 'react';
import { Container as Grid } from 'react-bootstrap';
import GetStartedError from './Error';
import GetStartedForm from './Form';
import GetStartedSuccess from './Success';


const GetStarted: React.FC = () => {

  useBodyClass(['get-started-page']);

  return (
    // @ts-ignore
    <Termite app='3 Steps to Get Started' noSession>
      <div className='main-section'>
        <Grid style={{ paddingTop: 44 }}>
          <GetStartedError />
          <GetStartedSuccess />
          <GetStartedForm />
        </Grid>
      </div>
    </Termite>
  );
}

export default GetStarted;